<ng-template #builderHost appComponentHost></ng-template>